import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "componentName"];

/**
 * Copyright IBM Corp. 2020, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
// Import portions of React that are needed.
import React from 'react'; // Other standard imports.

import PropTypes from 'prop-types';
import cx from 'classnames'; // load the package settings direct, because Canary is used by settings.js

import pkg from '../../global/js/package-settings'; // Carbon and package components we use.

import { CodeSnippet } from 'carbon-components-react'; // The block part of our conventional BEM class names (blockClass__E--M).

var blockClass = "".concat(pkg.prefix, "--canary");
/**
 *  Canary component used when the component requested is not yet production
 */

export var Canary = function Canary(_ref
/*, originalArgs*/
) {
  var className = _ref.className,
      componentName = _ref.componentName,
      rest = _objectWithoutProperties(_ref, _excluded);

  var instructions = "\nimport { pkg } from '@carbon/ibm-products';\n// NOTE: must happen before component is first used\npkg.component.".concat(componentName, " = true;\n");
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    className: cx(blockClass, className)
  }), /*#__PURE__*/React.createElement("h2", null, "This component ", /*#__PURE__*/React.createElement("strong", null, componentName), " is not ready yet."), /*#__PURE__*/React.createElement("p", null, "To enable it, initialize package flags before the component is first used."), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("p", null, "e.g. in main.js"), /*#__PURE__*/React.createElement(CodeSnippet, {
    type: "multi"
  }, instructions), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("p", null, "View a live example on", ' ', /*#__PURE__*/React.createElement("a", {
    href: "https://codesandbox.io/s/example-component-olif5?file=/src/config.js"
  }, "codesandbox"), "."));
};
Canary.propTypes = {
  /** Provide an optional class to be applied to the containing node */
  className: PropTypes.string,

  /** Name of the component that is not ready yet */
  componentName: PropTypes.string.isRequired
};